export const CHAT_SESSION_STORAGE_KEY = 'alphasearch.chat.sessionId';

export function readChatSessionId() {
  return sessionStorage.getItem(CHAT_SESSION_STORAGE_KEY);
}

export function rememberChatSession(sessionId) {
  const normalized = typeof sessionId === 'string' ? sessionId.trim() : '';
  if (!normalized) return null;
  sessionStorage.setItem(CHAT_SESSION_STORAGE_KEY, normalized);
  return normalized;
}

export function clearChatSession() {
  sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY);
}

export function openChatSession(sessionId, navigate) {
  const remembered = rememberChatSession(sessionId);
  if (!remembered) return false;
  navigate('/chat');
  return true;
}

export function openNewChat(navigate) {
  clearChatSession();
  navigate('/chat');
}
